import { render, staticRenderFns } from "./GetQuotesFromCarriersList.vue?vue&type=template&id=465e8136&"
import script from "./GetQuotesFromCarriersList.vue?vue&type=script&lang=js&"
export * from "./GetQuotesFromCarriersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465e8136')) {
      api.createRecord('465e8136', component.options)
    } else {
      api.reload('465e8136', component.options)
    }
    module.hot.accept("./GetQuotesFromCarriersList.vue?vue&type=template&id=465e8136&", function () {
      api.rerender('465e8136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/GetQuotesFromCarriers/GetQuotesFromCarriersList.vue"
export default component.exports